import { CommonCreativeBaseItem } from '../AddCreativePage/typings';
import { CreativeListItem } from '../common/creativesListTypings';

export interface BatchesListState {
    collection: BatchesCollection;
    creativesSelectorVisible: boolean;
    creativesSelectorDataProvider: CreativesBatchItem[];
    deleteConfirmVisible: boolean;
    idToDelete: string;
    presetsUrl: string;
}

export enum TriState {
    TRUE = 'true',
    FALSE = 'false',
    INDETERMINATE = 'indeterminate'
}

export interface CreativesBatchItem extends CommonCreativeBaseItem {
    name: string;
    batchId: string;
    archiveURL: string;
    screenshotURL: string;
    previewURL: string;
    fitsSizeFilter: boolean;
    data: {
        width: number;
        height: number;
        isAdaptive: boolean;
    };
    creativeURL: string;
}

export interface CreativesBatch extends CreativeListItem {
    selected: TriState;
    items: CreativesBatchItem[];
    filteredBySizeTotal: number;
    total: number;
}

export interface BatchesCollection {
    batches: CreativesBatch[];
    total: number;
}

export interface BatchesListProps {
    cls?: string;
    filteredSizes?: string[];
    creativesSelectorVisible: boolean;
    creativesSelectorDataProvider: CreativesBatchItem[];
    deleteConfirmVisible: boolean;
    showDeleteConfirm: (id: string) => void;
    showCreativesSelector: (id: string) => void;
    toggleSizesSelection: (ids: number[], selected: boolean) => void;
    submitSizesSelection: () => void;
    hideCreativesSelector: () => void;
    hideDeleteConfirm: () => void;
    delete: () => void;
    collection: BatchesCollection;
    isBusy: boolean;
    setSelection: (id: string, selected: boolean) => void;
    saveName: (id: string, val: string) => void;
    presetsUrl: string;
    load: (offset: number) => void;
    createBatch?: (id: string, isAdaptive?: boolean) => void;
}

export type SelectedBatches = {
    id: string;
    creativeIds: number[];
}[];
